import React from 'react';
export function Guarantee() {
  return <section className="w-full bg-navy-light py-16 md:py-24 px-4" data-id="element-140">
      <div className="max-w-xl mx-auto text-center" data-id="element-141">
        <span className="text-6xl mb-6 block text-cta" data-id="element-142">🛡️</span>

        <h2 className="text-2xl md:text-4xl font-bold text-white mb-4" data-id="element-143">
          Tu inversión está protegida
        </h2>

        <p className="text-cyan text-xl mb-8" data-id="element-144">
          Garantía de 30 días sin preguntas
        </p>

        <div className="text-white space-y-4" data-id="element-145">
          <p data-id="element-146">Aplica el protocolo de 14 noches.</p>
          <p data-id="element-147">Rastrea tus métricas en el workbook.</p>
          <p data-id="element-148">
            Si al día 14 no notas ninguna diferencia en tu energía al despertar
            o en tu calidad de descanso…
          </p>
          <p className="text-cta font-semibold text-lg" data-id="element-149">
            Te devolvemos el 100% de tu inversión.
          </p>
          <p className="text-gray-400" data-id="element-150">Sin preguntas complicadas.</p>
          <p className="text-gray-400" data-id="element-151">Sin trámites.</p>
          <p className="mt-6 text-gray-300" data-id="element-152">
            Creemos en este protocolo porque está basado en fisiología real.
          </p>
          <p className="text-white font-semibold" data-id="element-153">Si lo aplicas, funciona.</p>
        </div>
      </div>
    </section>;
}